import React, { useMemo, useState } from 'react';
import { Grid } from '@material-ui/core';
import { css } from '@emotion/react';
import { OnwardCard } from '@/components/OrderDetailsPage/Card';
import ExceptionCard from './ExceptionCard';
import ExceptionModal from '@/components/OrderDetailsPage/modals/Exceptions';
import ExceptionResolutionModal from '@/components/admin/AdminExceptions/modals/ExceptionResolutionModal';

function Exceptions({ order }) {
    const [exceptionParams, setExceptionParams] = useState(null);
    const [resolveExceptionParams, setResolveExceptionParams] = useState({});

    const itemExceptionGroups = useMemo(() => {
        const exceptionIdToGroup = {};

        (order?.itemsByOrderId || []).forEach((item) => {
            (item?.exceptions || []).forEach((mapping) => {
                const exceptionId = mapping?.exception?.exception_id;
                if (!exceptionIdToGroup[exceptionId]) {
                    exceptionIdToGroup[exceptionId] = { exception: mapping.exception, items: [] };
                }
                exceptionIdToGroup[exceptionId].items.push(item);
            });
        });

        (order?.exceptions || [])
            .filter(
                (mapping) => mapping?.exception_type === 'ITEM' && mapping?.item && mapping?.item?.order_id === null
            )
            .forEach((mapping) => {
                const exceptionId = mapping?.exception?.exception_id;
                if (!exceptionId) return;
                if (!exceptionIdToGroup[exceptionId]) {
                    exceptionIdToGroup[exceptionId] = { exception: mapping.exception, items: [] };
                }
                exceptionIdToGroup[exceptionId].items.push(mapping.item);
            });

        return Object.values(exceptionIdToGroup).map((group) => {
            const seenItemIds = new Set();
            group.items = group.items.filter((it) => {
                if (!it) return false;
                if (seenItemIds.has(it.item_id)) return false;
                seenItemIds.add(it.item_id);
                return true;
            });
            return group;
        });
    }, [order]);

    return (
        <>
            <ExceptionModal
                {...exceptionParams}
                loading={false}
                order={order}
                callbacks={{
                    onError: (e) => {
                        console.error(e);
                    },
                    onSubmitCreateAnother: ({ exception }) => {},
                    onSubmit: ({ exception }) => {},
                    onClose: () => setExceptionParams(null),
                }}
            />
            <ExceptionResolutionModal
                {...resolveExceptionParams}
                loading={false}
                callbacks={{
                    onClose: () => {
                        setResolveExceptionParams({});
                    },
                    onResolve: () => {},
                }}
            />
            <Grid item sm={1}></Grid>
            <Grid
                container
                sm={10}
                css={css`
                    height: 100%;
                    align-content: flex-start;
                `}
            >
                {!order?.exceptions?.length ? (
                    <OnwardCard
                        css={css`
                            margin-bottom: 30px;
                        `}
                    >
                        <span
                            css={css`
                                font-style: italic;
                            `}
                        >
                            No exceptions
                        </span>
                    </OnwardCard>
                ) : (
                    <>
                        <OnwardCard>
                            {(order?.exceptions || [])
                                .filter((mapping) => mapping.exception_type === 'ORDER')
                                .map((mapping) => {
                                    return (
                                        <Grid container className="mt-3">
                                            <ExceptionCard
                                                exception={mapping.exception}
                                                order={order}
                                                callbacks={{
                                                    setExceptionParams,
                                                    setResolveExceptionParams,
                                                }}
                                            />
                                        </Grid>
                                    );
                                })}

                            {itemExceptionGroups.map((group, idx) => {
                                const key = group?.exception?.exception_id || idx;
                                return (
                                    <Grid key={key} container className="mt-4">
                                        <ExceptionCard
                                            exception={group.exception}
                                            order={order}
                                            exceptionItems={group.items}
                                            callbacks={{
                                                setExceptionParams,
                                                setResolveExceptionParams,
                                            }}
                                        />
                                    </Grid>
                                );
                            })}
                        </OnwardCard>
                    </>
                )}
            </Grid>
            <Grid item sm={1}></Grid>
        </>
    );
}

export default Exceptions;
